import Vue from 'vue';
import App from './App.vue';
import Establishment from '@/views/Establishment.vue'
import routes from './router';
import vueCustomElement from 'vue-custom-element';
import VueRouter from 'vue-router';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(vueCustomElement);

const router = new VueRouter({
  routes,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');


Vue.customElement('establishment-sheet-admin', Establishment);